'use strict';

DoohApps
    .factory('ScheduleValidationHelper', ['$filter', '$q', 'DialogHandler', 'DoohHelper', 'ScheduleHelper', 'PaymentHelper', 'campaignBLL','RepeatData',
        function ($filter, $q, DialogHandler, DoohHelper, ScheduleHelper, PaymentHelper, CampaignBLL, RepeatData) {

            var availableForSchedulingBlocked = false;

            var messages = {
                errorMsgs: [],
                warningMsgs: [],
                scheduleError: ''
            }

            var ERROR_CODES = {
                loop: 'loop',
                checkPayment: 'checkPayment',
                saveSchedule: 'saveSchedule',
                priority: 'priority'
            }

            const DEF_REPEAT_TIME = 60,
                DEF_REPEAT_END_AFTER_COUNT = 2,
                DEF_REPEAT_PERIODICITY = 1;


            return {
                availableForScheduling: availableForScheduling,
                availableForSchedulingBlocked: availableForSchedulingBlocked,
                denyScheduling: denyScheduling,
                getMissingEvents: getMissingEvents,
                getRepeatSummary: getRepeatSummary,
                getRepeatEnd: getRepeatEnd,
                gatherCampaignSchedule: gatherCampaignSchedule,
                getStrRepeats: getStrRepeats,
                ERROR_CODES: ERROR_CODES,
                messages: messages,
            }

            function getUnsuccessfulAvailableForSchedulingPromise(deferred) {
                deferred.resolve({ isAvailableForSchedulingSuccessful: false });
                return deferred.promise;
            }

            function areRecurranceFieldsValid(repeatData) {
                if (repeatData.IsRecurrence && !areReapeatFieldsValid(repeatData)) {
                    messages.scheduleError = 'Invalid value detected';
                    denyScheduling();
                    availableForSchedulingBlocked = false;
                    return false;
                }
                return true;
            }

            function availableForScheduling(repeatData) {//validate
                var deferred = $q.defer();
                
                if (availableForSchedulingBlocked)
                    return getUnsuccessfulAvailableForSchedulingPromise(deferred);
                
                availableForSchedulingBlocked = true;
                messages.scheduleError = '';

                if (!areRecurranceFieldsValid(repeatData))
                    return getUnsuccessfulAvailableForSchedulingPromise(deferred);
                
                var mediaIds = [];
                var groupIds = [];
                
                repeatData = setDayRepeatCheckboxAsToday(repeatData);
                repeatData = correctInvalidNumberValues(repeatData);

                var missingInfo = getParametersForMissingEvents(repeatData);

                if (missingInfo.needMissingEvents && ScheduleHelper.userSelectedData.chosenDevices != null) {
                    angular.forEach(ScheduleHelper.userSelectedData.chosenDevices, function (chosenDevice) {
                        if (chosenDevice.hasLicense) {
                            if (DoohHelper.isValidAndMatchID(chosenDevice.MediaID)) mediaIds.push(chosenDevice.MediaID);
                            if (DoohHelper.isValidAndMatchID(chosenDevice.GroupID)) groupIds.push(chosenDevice.GroupID);
                        }
                    });
                }

                var missingStartDate = moment(!missingInfo.missingFrom ? repeatData.StartDateRepeat : missingInfo.missingFrom).format(DoohHelper.dcFormat);
                var missingEndDate = moment(repeatData.RepeatEndDate > repeatData.EndDate ?
                    repeatData.RepeatEndDate : repeatData.EndDate).format(DoohHelper.dcFormat);

                getMissingEvents(mediaIds, groupIds, missingStartDate, missingEndDate, repeatData)
                    .then(function (isGetMissingEventsSuccessful) {
                        messages.errorMsgs = messages.errorMsgs.filter(message => message.code !== ERROR_CODES.checkPayment && message.code !== ERROR_CODES.saveSchedule);

                        PaymentHelper.setInlineConfirmation(false);

                        ScheduleHelper.flags.isSchedulingAllowed = true;
                        ScheduleHelper.calendar.isRepeatAllowed = true;

                        repeatData = validateEventDates(repeatData);

                        ScheduleHelper.eventInfo.playtime = getPlayTime(repeatData.IsAllDay, ScheduleHelper.calendar.startDate, ScheduleHelper.calendar.endDate);

                        repeatData = validateRepeatConditions(repeatData);
                                                                  
                        availableForSchedulingBlocked = false;
                        deferred.resolve({
                            isAvailableForSchedulingSuccessful: true,
                            isGetMissingEventsSuccessful: isGetMissingEventsSuccessful
                        });
                    });
                return deferred.promise;
            }

            function validateEventDates(repeatData) {
                repeatData = clearOrUpdateRepeatInformation(repeatData);

                setStartDateForValidation(repeatData.StartDate, repeatData.StartTime);
                setEndDateForValidation(repeatData.EndDate, repeatData.EndTime);

                if (!repeatData.IsAllDay)
                    validateStartAndEndDateOrder(ScheduleHelper.calendar.startDate, ScheduleHelper.calendar.endDate, repeatData.IsAllDay);
                else
                    validateStartAndEndDateOrderForAllDay(ScheduleHelper.calendar.startDate, ScheduleHelper.calendar.endDate);

                return repeatData;
            }

            function validateRepeatConditions(repeatData) {
                if (repeatData.IsRecurrence && repeatData.TimeRepeat)
                {
                    validateTimeRepeats(repeatData.EndAtTime, repeatData.StartTime, repeatData.RepeatEndTime, repeatData.RepeatTime, repeatData.IsAllDay);
                    repeatData.TimeRepeatStartTime = getTimeRepeatStart(repeatData.TimeRepeatStartTime, repeatData.StartTime);
                }
                    

                validateRepeatEndDate(repeatData.EndDate, repeatData.RepeatEndDate, repeatData.IsRecurrence, repeatData.EndAfter, repeatData.IsAllDay);

                if (!repeatData.EndAfterCount && repeatData.EndAfter) {
                    repeatData.EndAfterCount = 1;
                    messages.scheduleError = 'Occurrence count must be more than 1!';
                    denyScheduling();
                }
                
                repeatData.StartDateRepeat = getRepeatStartDate(repeatData);

                return repeatData;
            }

            function areReapeatFieldsValid(repeatData) {
                if (repeatData.RepeatPeriod && !repeatData.RepeatEvery
                    || (repeatData.TimeRepeat && (!repeatData.RepeatTime || !(repeatData.RepeatTime >= 5 && repeatData.RepeatTime <= 720))))
                    return false;
                
                return true;
            }

            function denyScheduling() {
                ScheduleHelper.flags.isSchedulingAllowed = false;
                ScheduleHelper.calendar.isRepeatAllowed = false;
            }

            function setDayRepeatCheckboxAsToday(repeatData) {
                if (repeatData.WeekdayRepeat && (!repeatData.Monday && !repeatData.Tuesday
                    && !repeatData.Wednesday && !repeatData.Thursday
                    && !repeatData.Friday && !repeatData.Saturday && !repeatData.Sunday)) {
                    repeatData.WeekdayRepeat = false;
                    var today = moment().tz(localStorage['TimeZoneIANA']).format('dddd');
                    repeatData[today] = true;
                }
                return repeatData;
            }

            function correctInvalidNumberValues(repeatData) {
                if (!repeatData.TimeRepeat && !repeatData.RepeatTime)
                    repeatData.RepeatTime = DEF_REPEAT_TIME;

                if (!repeatData.RepeatPeriod && !repeatData.RepeatEvery)
                    repeatData.RepeatEvery = DEF_REPEAT_PERIODICITY;

                if (!repeatData.EndAfter && !repeatData.EndAfterCount)
                    repeatData.EndAfterCount = DEF_REPEAT_END_AFTER_COUNT;

                return repeatData;
            }

            function getParametersForMissingEvents(repeatData) {
                var missingFrom = ScheduleHelper.calendar.viewEndDate
                    ? ScheduleHelper.calendar.viewEndDate.format(DoohHelper.dcFormat)
                    : null;
                var needMissingEvents = missingFrom
                    ? moment(repeatData.RepeatEndDate).isSameOrAfter(ScheduleHelper.calendar.viewEndDate)
                    || moment(repeatData.EndDate).isSameOrAfter(ScheduleHelper.calendar.viewEndDate)
                    : false;
                return {
                    missingFrom: missingFrom,
                    needMissingEvents: needMissingEvents
                };
            }

            function getMissingEvents(mediaIds, groupIds, start, end, repeatData) {
                var deferred = $q.defer();
                if (mediaIds == '' && groupIds == '') {
                    ScheduleHelper.flags.isOverlapLoading = false;
                    deferred.resolve(false);
                    return deferred.promise;
                }
                var scheduleOptions = {};
                scheduleOptions.DeviceIds = mediaIds;
                scheduleOptions.GroupIds = groupIds;
                scheduleOptions.PeriodStart = start;
                scheduleOptions.PeriodEnd = end;
                scheduleOptions.ExtendPeriod = true;

                CampaignBLL.getSchedulerList(function (data) {
                    if (data.hasError) {
                        DialogHandler.AddError(data.error);
                    } else if (ScheduleHelper.userSelectedData.chosenCampaign != null) {
                        ScheduleHelper.calendar.missingEvents = data.content;
                        ScheduleHelper.calendar.combinedEvents = data.content.concat(ScheduleHelper.schedule.events).uniqueSchedules();

                        if (ScheduleHelper.eventInfo.repeatPlaceHolders == null)
                            ScheduleHelper.eventInfo.repeatPlaceHolders = [];

                        if (ScheduleHelper.userSelectedData.selectedEvent) {
                            ScheduleHelper.calendar.combinedEvents = ScheduleHelper.calendar.combinedEvents.filter(function (ev) {
                                return ScheduleHelper.userSelectedData.selectedEvent.ParentId == null
                                    || ev.ParentId != ScheduleHelper.userSelectedData.selectedEvent.ParentId;
                            });
                        }

                        ScheduleHelper.userSelectedData.chosenDevices = repeatData.IsRecurrence
                            ? ScheduleHelper.getScheduleConflictListRepeats(
                                ScheduleHelper.eventInfo.repeatPlaceHolders,
                                ScheduleHelper.calendar.combinedEvents,
                                ScheduleHelper.userSelectedData.chosenDevices,
                                ScheduleHelper.userSelectedData.chosenCampaign.IsBackground)
                            : ScheduleHelper.getScheduleConflictList(
                                moment(repeatData.StartDate).format(DoohHelper.dtcFormat),
                                moment(repeatData.EndDate).format(DoohHelper.dtcFormat),
                                ScheduleHelper.calendar.combinedEvents,
                                ScheduleHelper.userSelectedData.chosenDevices,
                                ScheduleHelper.userSelectedData.chosenCampaign.IsBackground);
                    }
                    deferred.resolve(true);
                }, scheduleOptions);

                return deferred.promise;
            }

            function clearOrUpdateRepeatInformation(repeatData) {
                if (repeatData.IsRecurrence == false) {
                    ScheduleHelper.eventInfo.repeatPlaceHolders = null;
                    ScheduleHelper.calendar.missingEvents = null;
                    repeatData.Saved = false;
                } else {
                    if (repeatData.Saved)
                        repeatData = getRepeatSummary(repeatData);
                }
                return repeatData;
            }

            function setStartDateForValidation(startDate, startTime) {
                ScheduleHelper.calendar.startDate = startDate;
                ScheduleHelper.calendar.startDate = DoohHelper.setTimeOfDate(ScheduleHelper.calendar.startDate, startTime);
            }

            function setEndDateForValidation(endDate, endTime) {
                ScheduleHelper.calendar.endDate = endDate;
                ScheduleHelper.calendar.endDate = DoohHelper.setTimeOfDate(ScheduleHelper.calendar.endDate, endTime);
            }

            function validateStartAndEndDateOrderForAllDay(startDate, endDate) {
                var eventStartMoment = moment(startDate);
                var eventEndMoment = moment(endDate);
                if (eventEndMoment.isBefore(eventStartMoment, ScheduleHelper.TIME_UNITS.days)) {
                    messages.scheduleError = 'End occurs before start';
                    ScheduleHelper.flags.isSchedulingAllowed = false;
                }
            }

            function validateStartAndEndDateOrder(startDate, endDate, isAllDay) {
                if (endDate < startDate) {
                    messages.scheduleError = 'End occurs before start';
                    ScheduleHelper.flags.isSchedulingAllowed = false;
                } else if ((endDate.getTime() - startDate.getTime()) < 300000 && !isAllDay) { // at least 5 mins
                    messages.scheduleError = 'Event must be at least 5 minutes long';
                    ScheduleHelper.flags.isSchedulingAllowed = false;
                }
            }

            function getPlayTime(isAllDay, startDate, endDate) {
                var eventStartMoment = moment(startDate);
                var eventEndMoment = moment(endDate);
                if (!isAllDay)
                    return `${eventEndMoment.diff(eventStartMoment, ScheduleHelper.TIME_UNITS.minutes)} ${ScheduleHelper.TIME_UNITS.minutes}`;

                var adjustedEventEndMoment = eventEndMoment.add(1, ScheduleHelper.TIME_UNITS.days);
                return `${adjustedEventEndMoment.diff(eventStartMoment, ScheduleHelper.TIME_UNITS.days)} day(s)`;
            }

            function validateTimeRepeats(isEndAtTime, startTime, repeatEndTime, repeatTime, isAllDay) {

                var diffMs = (ScheduleHelper.calendar.endDate - ScheduleHelper.calendar.startDate);
                var diffMins = Math.round(diffMs / 60000); // minutes
                if (isEndAtTime) {
                    var today = DoohHelper.getToday();
                    var testStart = DoohHelper.dateToMoment(today, startTime);
                    var testEnd = DoohHelper.dateToMoment(today, repeatEndTime);
                    var diffTMins = testEnd.diff(testStart, ScheduleHelper.TIME_UNITS.minutes);

                    if (diffTMins < diffMins) {
                        messages.scheduleError = 'Time repeat end time is less than end time';
                        denyScheduling();
                    }

                    if (testEnd.isBefore(testStart, ScheduleHelper.TIME_UNITS.minutes)) {
                        messages.scheduleError = 'Time repeat end time is less than start time';
                        denyScheduling();
                    }
                    if (repeatEndTime == startTime) {
                        messages.scheduleError = 'Repeat time cannot be the same as start time';
                        denyScheduling();
                    }
                }

                if (repeatTime < diffMins) {
                    messages.scheduleError = `Repeat time (${repeatTime} minute(s)) cannot be less than initial campaign length (${ScheduleHelper.eventInfo.playtime})`;
                    denyScheduling();
                }

                if (isAllDay) {
                    messages.scheduleError = 'All day event cannot be repeated with selected options';
                    denyScheduling();
                }
            }

            function validateRepeatEndDate(repeatDataEndDate, repeatDataRepeatEndDate, isRecurrence, isEndAfterCount, isAllDay) {
                var eventEndDate = new Date(repeatDataEndDate);
                var repeatEndDateMoment;

                if (repeatDataRepeatEndDate == null) {
                    messages.scheduleError = 'Invalid end date';
                    denyScheduling();
                } else {
                    if (typeof repeatDataRepeatEndDate == 'string') {
                        repeatEndDateMoment = DoohHelper.isDateStringinFormat(repeatDataRepeatEndDate)
                            ? repeatEndDateMoment = moment(repeatDataRepeatEndDate)
                            : moment(repeatDataRepeatEndDate, ScheduleHelper.SHORT_DATE_MOMENT);
                    } else repeatEndDateMoment = DoohHelper.dateToMoment(repeatDataRepeatEndDate);

                    var eventStartDateMoment = DoohHelper.dateToMoment(ScheduleHelper.calendar.startDate);
                    var eventEndDateMoment = DoohHelper.dateToMoment(eventEndDate);
                    var sameDay = isAllDay ? true : eventStartDateMoment.isSame(eventEndDateMoment, 'day');

                    if (isRecurrence && repeatEndDateMoment.diff(eventEndDate, ScheduleHelper.TIME_UNITS.days) < 0 && !isEndAfterCount && sameDay) {
                        messages.scheduleError = 'Event end date is greater than repeat end date';
                        denyScheduling();
                    }
                }
            }

            function getRepeatStartDate(repeatData) {
                if (!repeatData.IsRecurrence || ScheduleHelper.calendar.isRepeatStartChangeAllowed)
                    return moment(repeatData.StartDate).format(DoohHelper.dcFormat);
                
                if (repeatData.origData && !ScheduleHelper.calendar.isRepeatStartChangeAllowed)
                    return repeatData.origData.StartDateRepeat;

                return repeatData.StartDateRepeat;
            }

            function getRepeatSummary(repeatData) {
                if (messages.errorMsgs != null && messages.errorMsgs.length != 0)
                    messages.errorMsgs.pop();
                switch (repeatData.Repeats) {
                    case RepeatData.repeatOptions.REPEAT_WEEKS.value:
                        repeatData.Summary = getWeeksRepeatSummary(repeatData);
                        break;
                    case RepeatData.repeatOptions.REPEAT_DAYS.value:
                        repeatData.Summary = getDaysRepeatSummary(repeatData);
                        break;
                }
                return repeatData;
            }

            function getWeeksRepeatSummary(repeatData) {
                var time = repeatData.TimeRepeat
                    ? getTimeRepeatText(repeatData)
                    : '';

                return `${repeatData.EndAfter
                    ? `${updateWeeklyText(repeatData)} ,${repeatData.EndAfterCount} times`
                    : repeatData.EndsOn
                        ? `${updateTextWithEndDate(updateWeeklyText(repeatData), repeatData)} `
                        : `${updateWeeklyText(repeatData)}`} ${time}`;
            }

            function getTimeRepeatStart(timeRepeatStartTime, altStart) {
                return ScheduleHelper.eventInfo.hasEventStartTimeChanged
                    || !timeRepeatStartTime
                    || timeRepeatStartTime == ''
                    ? altStart
                    : timeRepeatStartTime;
            }

            function getTimeRepeatText(repeatData) {
                var startTime = getTimeRepeatStart(!repeatData.origData ? '' : repeatData.origData.TimeRepeatStartTime, ScheduleHelper.eventInfo.showTime.Start);
                return ` Every ${repeatData.RepeatTime} ${ScheduleHelper.TIME_UNITS.minutes}, from ${startTime} ${repeatData.EndAtTime
                    ? `to ${repeatData.RepeatEndTime}`
                    : `to end of day`}`;
            }

            function getDaysRepeatSummary(repeatData) {
                if (repeatData.RepeatTime == null)
                    return repeatData.Summary;

                if (ScheduleHelper.eventInfo.showTime == null || ScheduleHelper.eventInfo.showTime.RepeatEnd == null)
                    return repeatData.Summary;

                var time = repeatData.TimeRepeat
                    ? getTimeRepeatText(repeatData)
                    : '';
                let usedWeekDays = getUsedWeekDays(repeatData);
                var days = usedWeekDays.allWeekDaysSelected
                    ? ''
                    : `(${usedWeekDays.daysString})`;

                return `${repeatData.EndAfter
                    ? repeatData.RepeatEvery > 1
                        ? `Every ${repeatData.RepeatEvery} days`
                        : `${repeatData.StrRepeats} ${days} ,${repeatData.EndAfterCount} times`
                    : repeatData.EndsOn
                        ? updateTextWithEndDate(repeatData.RepeatEvery > 1
                            ? `Every ${repeatData.RepeatEvery} days ${days}`
                            : `${repeatData.StrRepeats} ${days}`, repeatData)
                        : repeatData.RepeatEvery > 1
                            ? `Every ${repeatData.RepeatEvery} days ${days}`
                            : `${repeatData.StrRepeats} ${days}`}. ${time}`;
            }

            function updateTextWithEndDate(string, repeatData) {
                if (repeatData.StartDateRepeat == null
                    || ScheduleHelper.eventInfo.hasStartDateChanged)
                    repeatData.StartDateRepeat = repeatData.StartDate;

                var repeatStartDate = DoohHelper.momentToDate(moment(repeatData.StartDateRepeat)),
                    endDate;

                if (typeof repeatData.RepeatEndDate == 'string') {
                    endDate = DoohHelper.isDateStringinFormat(repeatData.RepeatEndDate)
                        ? DoohHelper.stringToDate(repeatData.RepeatEndDate)
                        : DoohHelper.momentToDate(moment(repeatData.RepeatEndDate, ScheduleHelper.SHORT_DATE_MOMENT), true);
                }
                else
                    endDate = repeatData.RepeatEndDate;

                return endDate == null
                    ? ''
                    : `${string}${repeatData.EndsOn
                        ? `, from ${repeatStartDate.toDateString()} until ${endDate.toDateString()}`
                        : ``}`;
            }

            function updateWeeklyText(repeatData) {
                let usedWeekDays = getUsedWeekDays(repeatData);
                var days = usedWeekDays.allWeekDaysSelected
                    ? ''
                    : `${usedWeekDays.daysString}`;
                let weeklyText = `${repeatData.RepeatEvery > 1
                    ? `Every ${repeatData.RepeatEvery}. ${usedWeekDays.allWeekDaysSelected
                        ? ` week (daily),`
                        : ` week on `}`
                    : `${usedWeekDays.allWeekDaysSelected
                        ? `Every week (daily)`
                        : `Weekly on `}`} ${days}`;

                return weeklyText;
            }

            function getUsedWeekDays(repeatData) {
                let days = '';
                let allWeekDaysSelected = false;
                if (!repeatData.WeekdayRepeat)
                    allWeekDaysSelected = true;
                else {
                    if (repeatData.Saturday
                        && repeatData.Monday
                        && repeatData.Tuesday
                        && repeatData.Wednesday
                        && repeatData.Thursday
                        && repeatData.Friday
                        && repeatData.Sunday)
                        allWeekDaysSelected = true;
                    else {
                        days = ((repeatData.Sunday) ? 'Sun,' : '')
                            + ((repeatData.Monday) ? 'Mon,' : '')
                            + ((repeatData.Tuesday) ? 'Tue,' : '')
                            + ((repeatData.Wednesday) ? 'Wed,' : '')
                            + ((repeatData.Thursday) ? 'Thu,' : '')
                            + ((repeatData.Friday) ? 'Fri,' : '')
                            + ((repeatData.Saturday) ? 'Sat,' : '');
                        days = days.replace(/,$/, '');
                    }
                }

                return {
                    daysString: days,
                    allWeekDaysSelected: allWeekDaysSelected
                };
            }

            function getRepeatEnd(campaignSchedule) {
                var deferred = $q.defer();
                CampaignBLL.getRepeatEnd(function (data) {
                    deferred.resolve(data)
                }, campaignSchedule);
                return deferred.promise;
            }

            function getCampaignRecurreceInfo(campaignSchedule, repeatData) {
                var repeatDataCopy = angular.copy(repeatData);
                var endDate = new Date(repeatDataCopy.EndDate);
                if (repeatDataCopy.NeverEnds)
                    endDate.setFullYear(endDate.getFullYear() + 1);
                if (repeatDataCopy.EndAfter) {
                    endDate = new Date(campaignSchedule.TimeStart);
                    endDate.setDate(endDate.getDate() + 1);
                }

                if (typeof repeatDataCopy.RepeatEndDate != 'string') {
                    repeatDataCopy.RepeatEndDate = DoohHelper.dateToString(repeatDataCopy.RepeatEndDate, false);
                } else {
                    if (!DoohHelper.isDateStringinFormat(repeatDataCopy.RepeatEndDate)) {
                        repeatDataCopy.RepeatEndDate = moment(repeatDataCopy.RepeatEndDate, ScheduleHelper.SHORT_DATE_MOMENT).format(DoohHelper.dcFormat);
                    }
                }
                if (ScheduleHelper.eventInfo.isExistingEvent) {
                    var eventStartMoment = moment(campaignSchedule.TimeStart, DoohHelper.dtcFormat);
                    var eventEndMoment = moment(campaignSchedule.TimeEnd, DoohHelper.dtcFormat);
                    var differenceBetweenStartAndEnd = eventEndMoment.diff(eventStartMoment, ScheduleHelper.TIME_UNITS.hours, true);
                    var tzName = moment.tz.guess();
                    
                    if (typeof repeatDataCopy.StartDateRepeat != 'string')
                        repeatDataCopy.StartDateRepeat = moment(repeatDataCopy.StartDateRepeat).format(DoohHelper.dcFormat);
                    else {
                        if (repeatDataCopy.StartDateRepeat.indexOf('Z') != -1)
                            repeatDataCopy.StartDateRepeat = moment(repeatDataCopy.StartDateRepeat).tz(tzName).format(DoohHelper.dcFormat);
                        else
                            repeatDataCopy.StartDateRepeat = repeatDataCopy.StartDateRepeat.split(' ')[0];
                    }
                    campaignSchedule.TimeStart = `${repeatDataCopy.StartDateRepeat} ${repeatDataCopy.StartTime}`;
                    campaignSchedule.TimeEnd = moment(campaignSchedule.TimeStart).add(differenceBetweenStartAndEnd, ScheduleHelper.TIME_UNITS.hours).format(DoohHelper.dtcFormat);
                }

                repeatDataCopy.StartDate = campaignSchedule.TimeStart;
                repeatDataCopy.EndDate = `${DoohHelper.dateFormat(endDate).split(' ')[0]} ${repeatDataCopy.EndTime}`;
                repeatDataCopy.StrRepeats = getStrRepeats(repeatDataCopy);

                campaignSchedule.Recurrence = repeatDataCopy;
                campaignSchedule.Recurrence.EndDate = campaignSchedule.TimeEnd;
                campaignSchedule.JSONInfo = JSON.stringify(repeatDataCopy);
                return campaignSchedule;
            }

            function gatherCampaignSchedule(repeatData) {
                var campaignSchedule = {};
                campaignSchedule.TimeEnd = ScheduleHelper.normalizeRepeatDate(repeatData.EndDate, repeatData.EndTime, repeatData.IsAllDay, true);
                campaignSchedule.TimeStart = ScheduleHelper.normalizeRepeatDate(repeatData.StartDate, repeatData.StartTime, repeatData.IsAllDay);
                campaignSchedule.IsReoccurence = repeatData.IsRecurrence;
                campaignSchedule.IsAllDay = repeatData.IsAllDay;
                if (ScheduleHelper.userSelectedData.chosenCampaign != null)
                    campaignSchedule.IsBackground = ScheduleHelper.userSelectedData.chosenCampaign.IsBackground;

                if (repeatData.IsRecurrence) {
                    campaignSchedule = getCampaignRecurreceInfo(campaignSchedule, repeatData);
                }
                return campaignSchedule;
            }

            function getStrRepeats(repeatData) {
                return repeatData.StrRepeats != RepeatData.repeatOptions.REPEAT_DAYS.name
                    ? RepeatData.repeatOptions.REPEAT_WEEKS.name
                    : repeatData.StrRepeats
            }
            
        }]);